import { VueReCaptcha } from 'vue-recaptcha-v3'

export default defineNuxtPlugin(({ vueApp }) => {
    const config = useRuntimeConfig()
    const sitekey = `${config.public.recaptchaSiteKey}`

    vueApp.use(VueReCaptcha, {
        siteKey: sitekey,
        loaderOptions: {
            useRecaptchaNet: true,
            autoHideBadge: true
        }
    })
})
